import React, { Component } from "react";
import IconArrow from "ReactComponents/Shared/Icons/icon-arrow";

class SwiperNavigationButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button
                type="button"
                aria-label={this.props.ariaLabel}
                onClick={this.props.onClick}
                className={this.props.className}
            >
                <IconArrow direction={this.props.arrowDirection} />
            </button>
        );
    }
}

export default SwiperNavigationButton;
